// app/javascript/utils/select_state_municipality.js
export const initSelectStateMunicipality = (stateSelector, municipalitySelector, fetchUrl) => {
    const stateSelect = document.querySelector(stateSelector);
    const municipalitySelect = document.querySelector(municipalitySelector);
    console.log("[select_state] init", { stateSelect, municipalitySelect });
    if (!stateSelect || !municipalitySelect) return () => {}; // destroy no-op si nunca hubo init

    let currentRequest = null;

    const triggerSelect2 = (element) => {
        console.log("[select_state] triggerSelect2", element);
        if (typeof window.$ !== 'undefined' && window.$(element).hasClass('select2')) {
            // window.$(element).trigger('change');
            window.$(element).trigger('change.select2');
        }
    };

    const loadMunicipalities = (stateId) => {
        console.log("[select_state] loadMunicipalities", { stateId, fetchUrl });
        if (currentRequest) currentRequest.abort(); // cancela la petición anterior si seguía pendiente

        if (!stateId) {
            const blankOption = municipalitySelect.options[0];
            municipalitySelect.innerHTML = '';
            if (blankOption && blankOption.value === "") municipalitySelect.add(blankOption);
            triggerSelect2(municipalitySelect);
            return;
        }

        currentRequest = new AbortController();
        fetch(`${fetchUrl}?state_id=${stateId}`, {
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            signal: currentRequest.signal
        })
        .then(response => response.json())
        .then(data => {
            console.log("[select_state] municipios recibidos", data);
            const blankOption = municipalitySelect.options[0];
            municipalitySelect.innerHTML = '';
            if (blankOption && blankOption.value === "") municipalitySelect.add(blankOption);
            data.forEach(municipality => {
                municipalitySelect.add(new Option(municipality.display_name, municipality.id));
            });
            triggerSelect2(municipalitySelect);
        })
        .catch(error => {
            if (error.name === 'AbortError') return; // navegación/cambio rápido, no es un error real
            console.error('Error al cargar municipios:', error);
        });
    };

    const handleStateChange = function () {
        // console.log("[select_state] cambio de estado ->", window.$(this).val());
        console.log('[select_state] handleStateChange DISPARADO, valor:', window.$(this).val());
        loadMunicipalities(window.$(this).val());
    };
    const handleStateChangeNative = (e) => loadMunicipalities(e.target.value);

    if (typeof window.$ !== 'undefined') {
        // window.$(document)
        //     .off('change.state_municipality', stateSelector)
        //     .on('change.state_municipality', stateSelector, handleStateChange);
        window.$(stateSelect)
            .off('select2:select change', handleStateChange)
            .on('select2:select change', handleStateChange);
    } else {
        stateSelect.addEventListener('change', handleStateChangeNative);
    }

    // --- lo que init arma, destroy lo desarma ---
    return () => {
        if (currentRequest) currentRequest.abort();

        if (typeof window.$ !== 'undefined') {
            // // window.$(document).off('change.state_municipality', stateSelector);
            // window.$(stateSelect).off('select2:select change', handleStateChange);
            window.$(stateSelect).off('change.debug').on('change.debug', handleStateChange);
        } else {
            stateSelect.removeEventListener('change', handleStateChangeNative);
        }
        
    };
};